import axios, { AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { SimuladorState } from './state';

const API_URL = process.env.VUE_APP_URL_BACKEND;

const actions: ActionTree<SimuladorState, any> ={
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async simularCredito({ commit }, payload:any) {
        try {
            const { tipo_name, piso, estado, cuota_inicial, plazo } = payload;
            
            // Construir el JSON de la solicitud
            const requestData = { tipo_name, piso, estado, cuota_inicial, plazo };

            const response: AxiosResponse<any> = await axios.post(`${API_URL}api/auth/simular/`, requestData);
            commit('setResultado', response.data);
            return response.data;

        }  catch (error: any) {
            if (error.response && error.response.data && error.response.data.error) {
                // Aquí devolvemos el mensaje de error para mostrarlo al usuario
                return Promise.reject(error.response.data.error);
            } else {
                // Otro tipo de error inesperado
                return Promise.reject("Error inesperado al procesar la simulación.");
            }
        }
    },
    async tipoInmueble({ commit }) {
        try {
            const response: AxiosResponse<any> = await axios.get(`${API_URL}api/auth/tipos/`);
            commit('setTipos', response.data);
            return response.data;
        }  catch (error) {
            console.error('Error al generar tipoInmueble:', error);
            throw error;
        }
    },
    async obtenerPisosDisponibles({ commit }, payload: { tipo_name: string; estado: string }) {
        try {
            const response: AxiosResponse<any> = await axios.get(`${API_URL}api/auth/pisos-disponibles/`, {
            params: {
                tipo_name: payload.tipo_name,
                estado: payload.estado,
            },
            });
            commit('setPisos', response.data.pisos); // si usas pisos en el store
            return response.data.pisos;
        } catch (error) {
            console.error('Error al obtener los pisos disponibles:', error);
            return [];
        }
    },
    async cuotaInicialDisponible({ commit }, payload: { tipo_name: string; estado: string; piso: string }) {
        try {
            const response: AxiosResponse<any> = await axios.get(`${API_URL}api/auth/cuota-inicial-disponible/`, {
            params: {
                tipo_name: payload.tipo_name,
                estado: payload.estado,
                piso: payload.piso,
            },
            });

            // Commit si usas Vuex mutations para guardar valores
            commit('setCuotaInicial', response.data.cuota_inicial);
            return response.data.cuota_inicial;
            
            // Retorna ambos valores como un objeto
            
            
            
            // commit('setCuotaInicial', response.data.cuota_inicial); // si usas pisos en el store
            // return response.data.cuota_inicial;
        } catch (error) {
            console.error('Error al obtener la cuota Inicial Disponible:', error);
            return [];
        }
    },
    async plazoMaximoDisponible({ commit }, payload: { tipo_name: string; estado: string; piso: number; cuota_inicial: number; plazo: number }) {
        try {
            const response: AxiosResponse<any> = await axios.post(`${API_URL}api/auth/simular/`, payload);
            return response.data.plazo_maximo_anios;
        } catch (error) {
            console.error('Error al obtener el PlazoMaximoDisponible:', error);
            return null;
        }
    },
    async obtenerValorInmueble({ commit }, payload: { tipo_name: string; estado: string; piso: number; cuota_inicial: number; plazo: number }) {
        try {
            const response: AxiosResponse<any> = await axios.post(`${API_URL}api/auth/simular/`, payload);
            return response.data.valor_inmueble;
        } catch (error) {
            console.error('Error al obtener valor del inmueble:', error);
            return null;
        }
    },
};

export default actions;